import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody } from 'reactstrap';
import PhoneNumber from '../PhoneNumber/PhoneNumber';


class ElectronicDelivery extends Component {
  render() {
    const modalCloseButton = <div className="close-modal" onClick={this.props.onClickClose}></div>    
    return (
      <div>
        <Modal isOpen={this.props.visible} toggle={this.props.toggle} centered={true} className="get-started-modal"  modalClassName="get-started" external={modalCloseButton}>
          <div className="close-modal mobile" onClick={this.props.onClickClose}></div>
          <ModalBody className="terms-conditions">
            <h2>Personal information</h2>
            <div className="document-container">
              <div className="document">
                <p>By clicking ‘Submit Visa application’ below I consent to the collection, use and disclosure of my personal information in accordance with the section entitled “Protection of Personal Information” in the terms and conditions above and the Vancity Privacy Code which is available online at vancity.com or by calling <b><PhoneNumber value="1-888-826-2489">1-888-Vancity (826-2489)</PhoneNumber></b></p>
              </div>
            </div>       
            <div className="button-container">
              <Button onClick={this.props.onClickClose} color="primary">Done</Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

ElectronicDelivery.defaultProps= {  
  visible: false,
};

ElectronicDelivery.propTypes = {
  visible: PropTypes.bool,
  onClickClose: PropTypes.func
};

export default ElectronicDelivery;


// WEBPACK FOOTER //
// ./src/components/Submit/ElectronicDelivery.js